import { CustomerAccount } from 'src/app/data/CustomerAccount';
import { MerchantsComponent } from './../merchants/merchants.component';
import { Component, OnInit, OnDestroy, Injector } from '@angular/core';
import { Identity } from '../../Identity';
import { Subscription } from 'rxjs';
import { Card } from 'src/app/data/Card';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { CardholderService } from '../../services/cardholder.service';
import { Ship } from '../../Ship';
import { ShipRosterIdentity } from '../../data/ShipRosterIdentity';
import { ProfileSearchResult } from '../../data/ProfileSearchResult';
import { Router } from '@angular/router';

@Component({
  selector: 'app-merchant-accounts',
  templateUrl: './merchant-accounts.component.html',
  styleUrls: ['./merchant-accounts.component.css']
})
export class MerchantAccountsComponent
  extends MerchantsComponent
  implements OnDestroy, OnInit
{
  stripAccount: any = null;
  cardsAccount: any[] = [];
  chipsAccount: any[] = [];
  originalCardStatuses: string[] = [];
  originalChipStatuses: string[] = [];
  cardStatus: null;
  rowIndex: number;
  save_s_btn = false;
  save_a_btn = false;
  dataLoading = false;
  identity: Identity;
  merchantAccountInfoSub: Subscription;
  merchantSelectedSub: Subscription;
  users: string[];
  firstParameter = '';
  accountableOfficialSearchForm: UntypedFormGroup;
  search_btn_spinner = '';
  public ship: Ship;
  accountableOfficial = false;
  searchResults: ProfileSearchResult[];
  subview = '';
  search_btn = false;
  currentAOName: string;
  selected = false;
  public router: Router;

  constructor(injector: Injector) {
    super(injector);
    this.router = injector.get(Router);
  }

  ngOnInit() {
    this.initForm();
    this.dataLoading = true;
    this.merchantAccountInfoSub = this.merchantAccountInfoSet.subscribe(
      () => {
        if (this.merchantAccountInfo) {
          this.dataLoading = false;
          this.identity = this.merchantAccountInfo.identity;
          this.stripAccount = this.merchantAccountInfo.customerAccounts[0];
          this.chipsAccount = this.merchantAccountInfo.customerAccounts.slice(
            1,
            this.merchantAccountInfo.customerAccounts.length
          );
          this.cardsAccount = this.merchantAccountInfo.cardList;

          this.cardsAccount.forEach((element: Card, idx: number) => {
            this.originalCardStatuses.push(element.status);
          });
          this.chipsAccount.forEach((element: CustomerAccount, idx: number) => {
            this.originalChipStatuses.push(element.status);
          });
        }
      },
      (error) => {
        this.messageService.error('Error in retrieving merchant');
        this.dataLoading = false;
      }
    );

    this.merchantSelectedSub = this.merchantService.merchantSelected.subscribe(
      (data) => {
        this.merchantAccountInfoSet.emit(true);
      }
    );

    if(this.merchant){
    this.merchantService
      .getAccountableOfficial(this.merchant.ncMerchantNum)
      .subscribe((value: Object) => {
        if (value !== '') {
          this.currentAOName = value.toString().toUpperCase();
          this.accountableOfficial = true;
        }
      });
    } else {
      this.router.navigate(['merchantProfiles']);
      return;
    }

    if (!this.accountableOfficial) {
      this.shipService.getShipRoster(this.merchant.location).subscribe(
        (data: ShipRosterIdentity[]) => {
          this.users = data.map((identity) => {
            return identity.acct_num;
          });
        },
        (error) => {
          console.log('Error retrieving ship roster: ' + error);
          this.toastrService.error(
            'There was a problem fetching the ship roster '
          );
        }
      );
    }
  }

  saveAccounts(card: any, chipAccount: any, cardStatus: string, index: number) {
    // merchNum: number, shipLoc: string, card: object
    if (card.chipLimit > 99999.99) {
      this.messageService.error('Chip Limit cannot be greater than $99,999.99');
      return false;
    }
    this.rowIndex = index;
    this.save_a_btn = true;

    const merchNum = this.merchant.ncMerchantNum;
    const loc = this.merchant.location;
    const accounts = {};
    if (cardStatus !== undefined) {
      card['status'] = cardStatus;
    }

    if (card.status !== 'ACTIVE') {
      chipAccount.status = 'CLOSED';
    }

    accounts['card'] = card;
    accounts['customerAccount'] = chipAccount;

    this.merchantService.saveAccount(merchNum, loc, accounts).subscribe(
      () => {
        this.messageService.success('Saved');
        this.originalCardStatuses[index] = card.status;
        this.originalChipStatuses[index] = chipAccount.status;
        this.save_a_btn = false;
      },
      (error) => {
        this.save_a_btn = false;
        error.error
          ? this.messageService.error(error.error)
          : this.messageService.error('Error in saving');
      }
    );
  }

  syncProfile() {
    this.merchantService.syncAccount(this.stripAccount).subscribe(
      () => {
        this.messageService.success('Sync Successful');
      },
      () => {
        this.messageService.error('Error in Sync');
      }
    );
  }

  ngOnDestroy() {
    this.merchantAccountInfoSub.unsubscribe();
    this.merchantSelectedSub.unsubscribe();
  }

  saveStripAccount() {
    this.save_s_btn = true;
    const merchNum = this.merchant.ncMerchantNum;
    const loc = this.merchant.location;
    this.merchantService
      .saveStripAccount(merchNum, loc, this.stripAccount)
      .subscribe(
        () => {
          this.messageService.success('Saved');
          this.save_s_btn = false;
        },
        (error) => {
          if (error.error) {
            this.messageService.error(error.error);
          }
          this.save_s_btn = false;
        }
      );
  }

  submit() {
    this.searchResults = null;
    this.search_btn_spinner = 'fa fa-spinner fa-spin';
    this.search_btn = true;
    this.subview = 'results';
    if (this.firstParameter === undefined || this.firstParameter === '') {
      this.subview = 'noSearchParameters';
      this.search_btn_spinner = '';
      this.search_btn = false;
    } else {
      this.cardHolderService
        .searchCardHolders(this.firstParameter, this.merchant.location)
        .subscribe(
          (data) => {
            if (data.length === 0) {
              this.subview = 'noResults';
            } else {
              this.searchResults = data;
              this.subview = 'results';
            }
            this.search_btn_spinner = '';
            this.search_btn = false;
          },
          () => {
            console.log('Error finding cardholders');
          },
          () => {
            this.processing = false;
            const button = document.getElementById('searchButton');
            button.blur();
          }
        );
    }
  }

  initForm() {
    this.accountableOfficialSearchForm = new UntypedFormGroup({
      firstParameter: new UntypedFormControl('', {
        validators: [Validators.minLength(2)],
        updateOn: 'change'
      })
    });

    this.onChange();
  }

  onChange() {
    this.accountableOfficialSearchForm
      .get('firstParameter')
      .valueChanges.subscribe((search: string) => {
        this.firstParameter = search;
        this.accountableOfficialSearchForm.controls[
          'firstParameter'
        ].markAsTouched();
      });
  }

  isEMV(closedLoopPan) {
    return closedLoopPan != null;
  }

  showCardholder(cardholder: ProfileSearchResult) {
    CardholderService.storeCardHolder(cardholder);
    this.cardHolderService.storeCardholderResult(cardholder);
    this.merchantService
      .saveAccountableOfficial(
        cardholder.payrollAccount,
        this.merchant.ncMerchantNum,
        this.merchant.location
      )
      .subscribe(
        () => {
          this.messageService.success('Accountable Official has been added');
          this.accountableOfficial = true;
          this.currentAOName = cardholder.name;
          this.subview = '';
        },
        (error) => {
          if (error.error) {
            this.messageService.error(error.error);
          }
          this.accountableOfficial = false;
          this.subview = '';
        }
      );
  }

  reset() {
    this.merchantService
      .saveAccountableOfficial(
        0,
        this.merchant.ncMerchantNum,
        this.merchant.location
      )
      .subscribe(
        () => {
          this.messageService.success('Accountable Official has been removed');
          this.accountableOfficial = false;
          this.currentAOName = '';
          this.firstParameter = '';
        },
        (error) => {
          if (error.error) {
            this.messageService.error(error.error);
          }
        }
      );
  }

  hasEntitlements(entitlement) {
    return this.entitlementService.hasEntitlement(entitlement);
  }
}
